import "../styles/GetFplId.css";

import React from "react";

// Images
import GetFplIdLogin from "../assets/GetFplId/Get-FplId-Login.jpg";
import GetFplIdPoints from "../assets/GetFplId/Get-Fpl-Id-Points.jpg"; 
import GetFplIdUrl from "../assets/GetFplId/Read-url.png"; 

const GetFplId = () => {
  return (
    <>
      <div className="Get-Fpl-Id-overlay">
        <h1 className="Get-Fpl-Id-title">How to Get Your FPL ID</h1>
        <p className="Get-Fpl-Id-intro">
          Follow these simple steps to quickly locate your Fantasy Premier League (FPL) ID.
        </p>
        <p className="Get-Fpl-Id-intro"><strong>Note:</strong>Make sure you have the right FplId. It links to your fpl Team</p>

        <div className="Instructions-Section-Container">
          {/* Step 1 */}
          <div className="Instruction-Step">
            <div className="Instruction-Content">
              <h2 className="Instruction-Step-Title">Step 1: Log in</h2>
              <ul>
                <li>Go to fantasy.premierleague.com and log in to your FPL account.</li>
                <li>Do not use the FPL app. Use a browser like Chrome.</li>
              </ul>
            </div>
            <div className="Instruction-Image-Container">
              <img
                src={GetFplIdLogin}
                alt="FPL Login Page Example"
                className="Instruction-Image"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src =
                    "https://placehold.co/400x250/E0F2F7/2C3E50?text=Image+Not+Found";
                }}
              />
            </div>
          </div>

          {/* Step 2 */}
          <div className="Instruction-Step">
            <div className="Instruction-Content">
              <h2 className="Instruction-Step-Title">Step 2: Go to the Points Section</h2>
              <ul>
                <li>After logging in, click on the <strong>Points</strong> tab in the top menu.</li>
                <li>This will take you to your current gameweek points page.</li>
              </ul>
            </div>
            <div className="Instruction-Image-Container">
              <img
                src={GetFplIdPoints}
                alt="FPL Points Section Example"
                className="Instruction-Image"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src =
                    "https://placehold.co/400x250/E0F2F7/2C3E50?text=Image+Not+Found";
                }}
              />
            </div>
          </div>

          {/* Step 3 */}
          <div className="Instruction-Step3">
            <div className="Instruction-Content">
              <h2 className="Instruction-Step-Title">Step 3: Find Your FPL ID</h2>
              <ul>
                <li>Look at the URL in your browser’s address bar.</li>
                <li>Your FPL ID is the number that appears after <strong>/entry/</strong> in the link.</li>
                <li>
                  Example:
                  <div className="Example-Url">
                      <code>https://fantasy.premierleague.com/entry/1234567/event/1</code> 
                  </div> 
                    → Your FPL ID is <strong>1234567</strong>.
                </li>
              </ul>
            </div>
            <div className="Instruction-Image-Container">
              <img
                src={GetFplIdUrl}
                alt="FPL ID in URL Example"
                className="Instruction-Image3"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src =
                    "https://placehold.co/400x250/E0F2F7/2C3E50?text=Image+Not+Found";
                }}
              />
            </div>
          </div>
        </div>
        <h2>Still can't find it</h2>
        <button className="get-FplId-video" onClick={() => window.open("https://www.youtube.com/watch?v=e1mbj8SBYWk", "_blank")}>
            Youtube instructions
        </button>
      </div>
    </>
  );
};

export default GetFplId;
